var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1444.562,
    height: 1171.838,
    viewBox: "0 0 1444.562 1171.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forgot_Password",
    "data-name": "Forgot Password",
    transform: "translate(-3317.963 -11375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M15556.776-8435.655l191.24,20.368,178.413-87.888h450.376v-53.185h-820.029Z",
    transform: "translate(-11938 20296)",
    fill: "#89a983"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    transform: "translate(-1436.086 9564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(-2077.952 1688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M15691.422-8100.7v140.242h568.814V-8100.7Z",
    transform: "translate(-8423.963 9044)",
    fill: "#f9f5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(6769.949 45.96)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "vecteezy_hand-drawn-doodle-two-factor-authentication-and-verification_.eps",
    transform: "translate(6098.469 -178.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M1841.968-1477.111c95.341,9.743,193.041,6.81,288.818,8.732,90.992,1.854,185.827,15.542,276.446,7.854,15.812-1.348,14.228-25.048-.606-27.1-93.958-13.013-194.085-3.843-288.987-6.945-91.6-2.967-184.612-10.317-276.176-5.867C1828.011-1499.766,1829.057-1478.426,1841.968-1477.111Z",
    transform: "translate(-674.81 2609.05)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M2381.94-1381.069c-90.857-.034-181.645-3.44-272.435-5.867-42.781-1.146-85.529-1.719-128.277-2.157-40.658-.438-87.687-6.542-127.57,3.674,1.686-33.679,2.7-70.089-4.045-101.308-1.55-7.282-11.092-6.675-12.608.27-8.328,38.567-4.72,84.889-2.765,124.265.506,10.384,17.733,9.912,18.273-.4.169-3.573.371-7.247.54-10.889,37.218,10.923,78.989,7.214,117.456,8.226,45.411,1.214,90.789,2.326,136.234,2.8,90.89.91,181.814.843,272.637,4.18C2394.179-1357.74,2396.471-1381.036,2381.94-1381.069Z",
    transform: "translate(-674.903 2624.194)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M2087.782-1465.58c.371-20.969-32.6-24.138-32.229-3.607.573,31.117-3.574,66.482,6.843,96.184,2.9,8.326,15.98,7.383,18.745-.506C2091.154-1401.929,2087.209-1435.743,2087.782-1465.58Z",
    transform: "translate(-333.312 2637.766)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M1870.271-1453.42c13.384,0,15.845-20.868,2.359-20.868C1859.247-1474.288,1856.785-1453.42,1870.271-1453.42Z",
    transform: "translate(-629.752 2651.166)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M1909.326-1441.248c23.094,0,27.341-36.04,4.046-36.04C1890.244-1477.288,1886-1441.248,1909.326-1441.248Z",
    transform: "translate(-580.076 2646.579)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M1956.041-1435.656c27.577,0,32.634-43.018,4.821-43.018C1933.318-1478.674,1928.227-1435.656,1956.041-1435.656Z",
    transform: "translate(-513.218 2644.457)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M1997.339-1445.121c17.463,0,20.666-27.207,3.067-27.207C1982.978-1472.328,1979.775-1445.121,1997.339-1445.121Z",
    transform: "translate(-439.651 2654.164)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M2051.7-1476.511a50.93,50.93,0,0,1-7.114-1.011c-5.6-1.113-11.935,1.079-16.553,3.944A24.91,24.91,0,0,0,2019-1464a25.682,25.682,0,0,0,4.922,31.219,26.132,26.132,0,0,0,28.555,4.921c10.113-4.585,17.193-16.653,14.968-27.813a45.34,45.34,0,0,1-.978-6.708C2066.132-1469.33,2058.513-1476.106,2051.7-1476.511Z",
    transform: "translate(-393.582 2645.765)",
    fill: "#231f1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vecteezy_hand-drawn-doodle-two-factor-authentication-and-verification_.eps-2",
    "data-name": "vecteezy_hand-drawn-doodle-two-factor-authentication-and-verification_.eps",
    transform: "translate(5273.469 -1173.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069-2",
    "data-name": "Path 1069",
    d: "M1846.289-1477.111c135.938,9.743,275.24,6.81,411.8,8.732,129.737,1.854,264.954,15.542,394.16,7.854,22.545-1.348,20.287-25.048-.865-27.1-133.967-13.013-276.729-3.843-412.042-6.945-130.6-2.967-263.222-10.317-393.776-5.867C1826.389-1499.766,1827.88-1478.426,1846.289-1477.111Z",
    transform: "translate(34.544 3142.56)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071-2",
    "data-name": "Path 1071",
    d: "M2421.931-1381.069c-95.938-.034-191.8-3.44-287.671-5.867-45.174-1.146-90.313-1.719-135.452-2.157-42.932-.438-142.771,80.458-184.885,90.674,1.78-33.679-171.539-19.308-171.539-19.308s-11.712-6.675-13.313.27c-8.793,38.567,90.568,8.572,136.478,19.037s47.164,22.823,47.164,22.823.392-7.247.57-10.889c39.3,10.923,133.586-79.786,174.2-78.774,47.951,1.214,95.867,2.326,143.853,2.8,95.973.91,191.982.843,287.885,4.18C2434.854-1357.74,2437.274-1381.036,2421.931-1381.069Z",
    transform: "translate(237.621 3085.82)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073-2",
    "data-name": "Path 1073",
    d: "M2087.782-1375.025c.371-129.665-32.6-149.262-32.229-22.3.573,192.419-3.574,411.1,6.843,594.765,2.9,51.488,15.98,45.656,18.745-3.128C2091.154-981.431,2087.209-1190.522,2087.782-1375.025Z",
    transform: "translate(614.688 3123.772)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M2087.782-874.475c.371,129.665-32.6,149.262-32.23,22.3.573-192.419-3.574-411.1,6.843-594.766,2.9-51.488,15.98-45.656,18.745,3.128C2091.154-1268.068,2087.209-1058.977,2087.782-874.475Z",
    transform: "translate(-205.278 3123.772)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M2653.757-1477.111c-135.938,9.744-275.24,6.81-411.8,8.732-129.737,1.854-264.954,15.542-394.16,7.854-22.545-1.348-20.287-25.048.865-27.1,133.967-13.013,276.729-3.843,412.042-6.945,130.6-2.967,263.222-10.317,393.776-5.867C2673.657-1499.766,2672.167-1478.426,2653.757-1477.111Z",
    transform: "translate(34.543 3859.159)",
    fill: "#231f1f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 17.073,
    cy: 17.073,
    rx: 17.073,
    ry: 17.073,
    transform: "matrix(-0.998, -0.07, 0.07, -0.998, 5373.559, 2087.888)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M76.827,136.581c0-19.941,13.061-30.287,22.621-39.8,11.866-11.8,20.06-23.389,20.06-37.031A59.754,59.754,0,1,0,0,59.754a17.073,17.073,0,0,0,34.145,0,25.609,25.609,0,1,1,51.218,0c0,2.971-2.544,4.951-4.814,7.478-3.449,3.807-7.563,7.631-11.661,11.831-13.4,13.727-26.206,30.731-26.206,57.518a17.073,17.073,0,1,0,34.145,0Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 5310.615, 1886.672)",
    fill: "#63805f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 10.082,
    cy: 10.082,
    rx: 10.082,
    ry: 10.082,
    transform: "translate(5248.541 2111.628) rotate(149)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M45.371,80.659c0-11.776,7.713-17.886,13.359-23.5,7.007-6.967,11.847-13.813,11.847-21.869A35.288,35.288,0,1,0,0,35.288a10.082,10.082,0,0,0,20.165,0,15.124,15.124,0,1,1,30.247,0c0,1.754-1.5,2.924-2.843,4.416-2.037,2.248-4.466,4.507-6.886,6.987C32.768,54.8,25.206,64.84,25.206,80.659a10.082,10.082,0,0,0,20.165,0Z",
    transform: "translate(5149.934 2035.608) rotate(-31)",
    fill: "#63805f",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_4016cf7d16ff972f7ff2a8bd3a64cd88",
    "data-name": "4016cf7d16ff972f7ff2a8bd3a64cd88",
    transform: "translate(3548.5 11575.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M188.923,187.923H69.706A44.706,44.706,0,0,1,25,143.217V68.706A44.706,44.706,0,0,1,69.706,24H188.923a44.706,44.706,0,0,1,44.706,44.706v74.51A44.706,44.706,0,0,1,188.923,187.923ZM69.706,53.8a14.9,14.9,0,0,0-14.9,14.9v74.51a14.9,14.9,0,0,0,14.9,14.9H188.923a14.9,14.9,0,0,0,14.9-14.9V68.706a14.9,14.9,0,0,0-14.9-14.9Z",
    transform: "translate(362.43 360.233)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M161.119,123.315H41.9a14.9,14.9,0,0,1-14.9-14.9V93.51a74.51,74.51,0,1,1,149.021,0v14.9A14.9,14.9,0,0,1,161.119,123.315ZM56.8,93.51h89.413a44.706,44.706,0,1,0-89.413,0ZM101.51,197.825a14.9,14.9,0,0,1-14.9-14.9v-14.9a14.9,14.9,0,0,1,29.8,0v14.9A14.9,14.9,0,0,1,101.51,197.825Z",
    transform: "translate(390.234 290.723)",
    fill: "#63805f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassSvg);
export default __webpack_public_path__ + "static/media/resetPassSvg.d77d4e41c8923de8e445f46c6de03779.svg";
export { ForwardRef as ReactComponent };